import { FC, useRef } from 'react';
import { useSelector } from 'react-redux';
import { CSSTransition } from 'react-transition-group';

import { RootState } from '../../../ducks/store';

import './OutletWrapper.scss';

interface IProps {}

const OutletWrapper: FC<IProps> = ({ children }) => {
  const panelOpen = useSelector((state: RootState) => state.navPanel.panelOpen);

  const ref = useRef(null);
  return (
    <CSSTransition in={panelOpen} timeout={200} classNames="OutletWrapper" nodeRef={ref}>
      <div className="OutletWrapper" ref={ref}>
        {children}
      </div>
    </CSSTransition>
  );
};

export default OutletWrapper;
